import React from 'react';
import DataSourcesPage from 'dataSources/components/DataSourcesPage';
import { useDispatch, useSelector } from 'react-redux';
import { PAGE_DATA_TYPES } from '../utils';
import { getAdNetworks, getDataSourcesPage } from '../selector';
import { closeShelf, deleteUan, export2Phase, loginVerificationFinished, openShelf } from '../actions';
import DataDestinationsShelfEnv from './DataDestinationShelfEnv';
import { ETL_EVENT_PREFIX } from '../../utils/general';
import { DATA_DESTINATIONS_EMPTY_STATE_CONNECTORS } from '../../utils/consts';

export default function DataDestinationsPage() {
    const dispatch = useDispatch();
    const pageProps = useSelector(state => getDataSourcesPage(state));
    const adnetworks = useSelector(state => getAdNetworks(state));
    const filteredUansData = pageProps.uansData.filter(item => !item.migratedToExtract);

    return (
        <DataSourcesPage
            {...pageProps}
            uansData={filteredUansData}
            adnetworks={adnetworks}
            adNetworkOptions={pageProps.adNetworkOptions}
            redirectPath="react/data-destinations"
            archivedToggleEnabled={false}
            translationPageKey={PAGE_DATA_TYPES.DATA_DESTINATIONS}
            emptyStateDataConnectors={DATA_DESTINATIONS_EMPTY_STATE_CONNECTORS}
            mixpanelPrefix={ETL_EVENT_PREFIX}
            export2Phase={uanId => dispatch(export2Phase(uanId))}
            onValidationFinished={uanId => dispatch(loginVerificationFinished(uanId))}
            openShelf={(adnetDisplayName, uanId) => dispatch(openShelf(adnetDisplayName, uanId))}
            onCloseShelf={() => dispatch(closeShelf())}
            onUanDelete={uanId => dispatch(deleteUan(uanId))}
            externalShelfElement={DataDestinationsShelfEnv}
        />
    );
}
